export default [
  // {
  //   path: "/custom-module/:page",
  //   name: "custom-module",
  //   component: () =>
  //     import("@/views/pages/customs-module/CustomModule.vue"),
  //   meta: {},
  //   breadcrumb: [],
  // },
  // relate breadscrum
  {
    path: "/custom-customer/list",
    name: "custom-customer-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Customer Management",
      },
      {
        text: "Customer List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-customer/:CustomerId/detail",
    name: "custom-customer-detail",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Customer Management",
      },
      {
        text: "Customer List",
        to: "/custom-customer/detail",
      },
      {
        text: "Customer Detail",
        active: true,
      },
    ],
  },
  {
    path: "/custom-customer/:CustomerId/edit",
    name: "custom-customer-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Customer Management",
      },
      {
        text: "Customer Detail",
        to: "/custom-customer/edit",
      },
      {
        text: "Customer Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-merchant/list",
    name: "custom-merchant-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Merchant Management",
      },
      {
        text: "All Merchant",
        active: true,
      },
    ],
  },
  {
    path: "/custom-merchant/create",
    name: "custom-merchant-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Merchant Management",
      },
      {
        text: "All Merchant",
        to: "/custom-merchant/create",
      },
      {
        text: "Merchant Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-merchant/:MerchantId/edit",
    name: "custom-merchant-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Merchant Management",
      },
      {
        text: "All Merchant",
        to: "/custom-merchant/edit",
      },
      {
        text: "Merchant Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/list",
    name: "custom-promotion-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/create-general",
    name: "custom-promotion-create-general",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        to: "/custom-promotion/detail",
      },
      {
        text: "Promotion Create Promotion",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/:promotionId/edit-general",
    name: "custom-promotion-edit-general",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        to: "/custom-promotion/detail",
      },
      {
        text: "Promotion Edit Promotion",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/:promotionId/edit-point",
    name: "custom-promotion-edit-point",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        to: "/custom-promotion/detail",
      },
      {
        text: "Promotion Edit Promotion",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/:promotionId/edit-tier",
    name: "custom-promotion-edit-tier",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        to: "/custom-promotion/detail",
      },
      {
        text: "Promotion Edit Promotion",
        active: true,
      },
    ],
  },
  {
    path: "/custom-promotion/:promotionId/edit-spending",
    name: "custom-promotion-edit-spending",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Point Management",
      },
      {
        text: "Promotion List",
        to: "/custom-promotion/detail",
      },
      {
        text: "Promotion Edit Promotion",
        active: true,
      },
    ],
  },
  {
    path: "/custom-adjust-user/create",
    name: "custom-adjust-user-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Adjust User",
      },
      {
        text: "Adjust User Create",
        active: true,
      },
    ],
  },
  
  {

    path: "/custom-adjust-user/list",
    name: "custom-adjust-user-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Adjust User",
      },
      {
        text: "Adjust User List",

        active: true,
      },
    ],
  },
  {
    path: "/custom-setting/popup",
    name: "custom-setting-popup",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Setting",
      },
      {
        text: "Config Text Popup",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-import-file/list",
    name: "custom-user-import-file-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Import File",
      },
      {
        text: "User Import File List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-collect-point-by-admin/list",
    name: "custom-collect-point-by-admin-approved-receipt-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Collect Point By Admin",
      },
      {
        text: "Approved Receipt",
        active: true,
      },
    ],
  },
  {
    path: "/custom-collect-point-by-admin/:CustomerId/:DocumentId/history-customer",
    name: "custom-collect-point-by-admin-history-customer",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Collect Point By Admin",
      },
      {
        text: "Approved Receipt",
        to: "/custom-collect-point-by-admin/history-customer",
      },
      {
        text: "Approved Receipt Info",
        active: true,
      },
    ],
  },
  {
    path: "/custom-collect-point-by-counter/adjust-receipt",
    name: "custom-collect-point-by-counter-adjust-receipt",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Collect Point By Counter",
      },
      {
        text: "Adjust Receipt",
        active: true,
      },
    ],
  },
  {
    path: "/custom-collect-point-by-counter/adjust-receipt-create",
    name: "custom-collect-point-by-counter-adjust-receipt-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Collect Point By Counter",
      },
      {
        text: "Adjust Receipt",
        to: "/custom-collect-point-by-counter/adjust-receipt",
      },
      {
        text: "Adjust Receipt Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/list",
    name: "custom-article-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/create",
    name: "custom-article-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article List",
        to: "/custom-article/list",
      },
      {
        text: "Article Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/:id/info",
    name: "custom-article-info",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article List",
        to: "/custom-article/list",
      },
      {
        text: "Article Info",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/category",
    name: "custom-article-category",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article Category",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/category-create",
    name: "custom-article-category-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article Category",
        to: "/custom-article/category",
      },
      {
        text: "Article Category Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-article/:id/category-info",
    name: "custom-article-category-info",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Article",
      },
      {
        text: "Article Category",
        to: "/custom-article/category",
      },
      {
        text: "Article Category Info",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/role-list",
    name: "custom-user-management-role-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "Roles",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/role-list/create",
    name: "custom-user-management-role-list-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "Role",
        to: "/custom-user-management/role-list",
      },
      {
        text: "Create Role",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/role-list/:id/edit/",
    name: "custom-user-management-role-list-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "Role",
        to: "/custom-user-management/role-list",
      },
      {
        text: "Edit Role",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/user-access-list",
    name: "custom-user-management-user-access-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "User Access",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/user-access-create",
    name: "custom-user-management-user-access-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "User Access",
        to: "/custom-user-management/user-access-list",
      },
      {
        text: "User Access Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/:id/user-access-edit",
    name: "custom-user-management-user-access-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "User Access",
        to: "/custom-user-management/user-access-list",
      },
      {
        text: "User Access Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-user-management/:id/user-access-forget-password",
    name: "custom-user-management-user-access-forget-password",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "User Management",
      },
      {
        text: "User Access",
        to: "/custom-user-management/user-access-list",
      },
      {
        text: "User Access Forget Password",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/friend-referral-list",
    name: "custom-mission-friend-referral-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Friend Referal",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/friend-referral-create",
    name: "custom-mission-friend-referral-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Friend Referal",
        to: "/custom-mission/friend-referral-list",
      },
      {
        text: "Friend Referal Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/:id/friend-referral-edit",
    name: "custom-mission-friend-referral-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Friend Referal",
        to: "/custom-mission/friend-referral-list",
      },
      {
        text: "Friend Referal Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/mission-group-list",
    name: "custom-mission-mission-group-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Mission Group",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/mission-group-create",
    name: "custom-mission-mission-group-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Mission Group",
        to: "/custom-mission/mission-group-list",
      },
      {
        text: "Mission Group Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/:id/mission-group-edit",
    name: "custom-mission-mission-group-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Mission Group",
        to: "/custom-mission/mission-group-list",
      },
      {
        text: "Mission Group Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/mission-list-create",
    name: "custom-mission-mission-list-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Mission Group",
        to: "/custom-mission/mission-group-list",
      },
      {
        text: "Mission List Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-mission/:id/mission-list-edit",
    name: "custom-mission-mission-list-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Mission",
      },
      {
        text: "Mission Group",
        to: "/custom-mission/mission-group-list",
      },
      {
        text: "Mission List Edit",
        active: true,
      },
    ],
  },
  // {
  //   path: "/custom-setting/popup",
  //   name: "custom-setting-popup",
  //   component: () =>
  //     import("@/views/pages/customs-module/CustomModule.vue"),
  //   meta: {},
  //   breadcrumb: [
  //     {
  //       text: "Setting",
  //     },
  //     {
  //       text: "Config Text Popup",
  //       active: true,
  //     },
  //   ],
  // },
  // {
  //   path: "/custom-setting/popup/:MerchantId/edit",
  //   name: "custom-setting-popup-edit",
  //   component: () =>
  //     import("@/views/pages/customs-module/CustomModule.vue"),
  //   meta: {},
  //   breadcrumb: [
  //     {
  //       text: "Setting",
  //     },
  //     {
  //       text: "Config Text Popup",
  //       to: "/custom-setting/popup",
  //     },
  //     {
  //       text: "Edit Config Text Popup",
  //       active: true,
  //     }
  //   ],
  // },
  {
    path: "/custom-privilege/list",
    name: "custom-privilege-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Privilege List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/create",
    name: "custom-privilege-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Privilege List",
        to: "/custom-privilege/list",
      },
      {
        text: "Privilege Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/edit",
    name: "custom-privilege-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Privilege List",
        to: "/custom-privilege/list",
      },
      {
        text: "Privilege Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/category-mapping-edit",
    name: "custom-privilege-category-mapping-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Privilege List",
        to: "/custom-privilege/list",
      },
      {
        text: "Privilege Category Mapping",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/tag",
    name: "custom-privilege-tag",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Privilege List",
        to: "/custom-privilege/list",
      },
      {
        text: "Privilege Tag",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/category-list",
    name: "custom-privilege-category-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Category",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/category-create",
    name: "custom-privilege-category-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Category",
        to: "/custom-privilege/category-list",
      },
      {
        text: "Category Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/category-edit",
    name: "custom-privilege-category-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Category",
        to: "/custom-privilege/category-list",
      },
      {
        text: "Category Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/subcategory-list",
    name: "custom-privilege-subcategory-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Sub Category",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/subcategory-create",
    name: "custom-privilege-subcategory-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Sub Category",
        to: "/custom-privilege/subcategory-list",
      },
      {
        text: "Sub Category Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/subcategory-edit",
    name: "custom-privilege-subcategory-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Sub Category",
        to: "/custom-privilege/subcategory-list",
      },
      {
        text: "Sub Category Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/group-category-list",
    name: "custom-privilege-group-category-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Group Category",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/group-category-create",
    name: "custom-privilege-group-category-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Group Category",
        to: "/custom-privilege/group-category-list",
      },
      {
        text: "Group Category Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-privilege/:id/group-category-edit",
    name: "custom-privilege-group-category-edit",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Privilege",
      },
      {
        text: "Group Category",
        to: "/custom-privilege/group-category-list",
      },
      {
        text: "Group Category Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-report",
    name: "custom-report",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Report',
        active: true,
      },
      {
        text: "Report List",
        to: "/custom-report",
      },
    ]
  },
  {
    path: "/custom-virtual-card/list",
    name: "custom-virtual-card-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Virtual Card List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card/create",
    name: "custom-virtual-card-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Virtual Card List",
        to: "/custom-virtual-card/list",
      },
      {
        text: "Virtual Card Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card/:id/edit",
    name: "custom-virtual-card-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Virtual Card List",
        to: "/custom-virtual-card/list",
      },
      {
        text: "Virtual Card Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card/:id/image",
    name: "custom-virtual-card-image",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Virtual Card List",
        to: "/custom-virtual-card/list",
      },
      {
        text: "Virtual Card Image",
        active: true,
      },
    ],
  },
  {
    path: "/custom-application-group/list",
    name: "custom-application-group-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Application Group List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-application-group/create",
    name: "custom-application-group-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Application Group List",
        to: "/custom-application-group/list",
      },
      {
        text: "Application Group Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-application-group/:id/edit",
    name: "custom-application-group-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card",
      },
      {
        text: "Application Group List",
        to: "/custom-application-group/list",
      },
      {
        text: "Application Group Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card-for-sbu/admin-approved-list",
    name: "custom-virtual-card-for-sbu-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
          text: 'Virtual Card for SBUs',
          active: true,
      },
      {
          text: "Admin Approved",
          to: "/custom-virtual-card-for-sbu/admin-approved-list",
      },
    ]
  },
  {
    path: "/custom-virtual-card-for-sbu/:CustomerId/detail/:CardId",
    name: "custom-virtual-card-for-sbu-detail",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card for SBUs",
      },
      {
        text: "Admin Approved",
        to: "/custom-virtual-card-for-sbu/admin-approved-list",
      },
      {
        text: "Admin Approved Detail",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card-for-sbu/:CustomerId/edit/:CardId/:Tab?",
    name: "custom-virtual-card-for-sbu-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card for SBUs",
      },
      {
        text: "Admin Approved",
        to: "/custom-virtual-card-for-sbu/admin-approved-list",
      },
      {
        text: "View Detail",
        to: "/custom-virtual-card-for-sbu/:CustomerId/detail",
      },
      {
        text: "Edit Admin Approved",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card-for-sbu/create",
    name: "custom-virtual-card-for-sbu-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Virtual Card for SBUs",
      },
      {
        text: "Admin Approved",
        to: "/custom-virtual-card-for-sbu/admin-approved-list",
      },
      {
        text: "Add Membership Card",
        active: true,
      },
    ],
  },
  {
    path: "/custom-virtual-card-for-sbu/admin-upload-file-list",
    name: "custom-virtual-card-for-sbu-upload-file-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
          text: 'Virtual Card for SBUs',
          active: true,
      },
      {
          text: "Admin Upload File",
          to: "/custom-virtual-card-for-sbu/admin-upload-file-list",
      },
    ]
  },
  // e-stamp
  {
    path: "/custom-e-stamp/list",
    name: "custom-e-stamp-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "E-stamp List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp/create",
    name: "custom-e-stamp-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "E-stamp List",
        to: "/custom-e-stamp/list"
      },
      {
        text: "Create E-stamp",
        active: true,
      },
    ],
  },
    {
    path: "/custom-e-stamp/:edit/edit",
    name: "custom-e-stamp-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "E-stamp List",
        to: "/custom-e-stamp/list"
      },
      {
        text: "Edit E-stamp",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-template/list",
    name: "custom-e-stamp-template",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Template E-stamp",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-template/create",
    name: "custom-e-stamp-template-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Template E-stamp",
        to: "/custom-e-stamp-template/list",
      },
      {
        text: "Template E-stamp Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-template/:id/edit",
    name: "custom-e-stamp-template-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Template E-stamp",
        to: "/custom-e-stamp-template/list",
      },
      {
        text: "Template E-stamp Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-icon/list",
    name: "custom-e-stamp-icon",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Icon E-stamp",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-icon/create",
    name: "custom-e-stamp-icon-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Icon E-stamp",
        to: "/custom-e-stamp-icon/list",
      },
      {
        text: "Icon E-stamp Create",
        active: true,
      },
    ],
  },
  {
    path: "/custom-e-stamp-icon/:id/edit",
    name: "custom-e-stamp-icon-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "E-stamp",
      },
      {
        text: "Icon E-stamp",
        to: "/custom-e-stamp-icon/list",
      },
      {
        text: "Icon E-stamp Edit",
        active: true,
      },
    ],
  },
  {
    path: "/custom-adjust-e-stamp-point/list",
    name: "custom-adjust-e-stamp-point",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Adjust E-stamp",
      },
      {
        text: "Adjust E-stamp Point",
        active: true,
      },
    ],
  },
  {
    path: "/custom-adjust-e-stamp-point/create",
    name: "custom-adjust-e-stamp-point-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Adjust E-stamp",
      },
      {
        text: "Adjust E-stamp Point",
        to: "/custom-adjust-e-stamp-point/list",
      },
      {
        text: "Adjust E-stamp Point Create",
        active: true,
      },
    ],
  },
  //inventory
  {
    path: "/custom-inventory/privilege/list",
    name: "custom-inventory-privilege-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: 'Privilege',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/manage-master/:ref",
    name: "custom-inventory-privilege-manage-master",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: 'Privilege',
        active: true,
      },
      {
        text: 'Manage Master',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/manage-custom/create",
    name: "custom-inventory-privilege-manage-custom-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: 'Privilege',
        active: true,
      },
      {
        text: 'Add Inventory',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/manage-custom/info/:ref",
    name: "custom-inventory-privilege-manage-custom-info",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: 'Privilege',
        active: true,
      },
      {
        text: 'Manage Inventory',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/history/group/:ref",
    name: "custom-inventory-privilege-history-group",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: 'Privilege',
        active: true,
      },
      {
        text: 'Manage Master',
        active: true,
      },
      {
        text: 'History',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/history/group/:ref/detail/:invRef",
    name: "custom-inventory-privilege-history-detail",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: '...',
        active: true,
      },
      {
        text: 'History Detail',
        active: true,
      },
    ],
  },
  {
    path: "/custom-inventory/privilege/history/group/:ref/detail/:invRef/stock",
    name: "custom-inventory-privilege-stock-detail",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: '...',
        active: true,
      },
      {
        text: 'History Detail',
        active: true,
      },
      {
        text: 'Total Stock',
        active: true,
      }
    ],
  },
  {
    path: "/custom-inventory/privilege/history/group/:ref/detail/:invRef/stock/:stockRef",
    name: "custom-inventory-privilege-stock-detail-byref",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: '...',
        active: true,
      },
      {
        text: 'History Detail',
        active: true,
      },
      {
        text: 'Serial Stock',
        active: true,
      }
    ],
  },
  {
    path: "/custom-inventory/privilege/history/group/:ref/detail/:invRef/import/:importRef",
    name: "custom-inventory-privilege-import-detail-byref",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Inventory Management',
      },
      {
        text: '...',
        active: true,
      },
      {
        text: 'History Detail',
        active: true,
      },
      {
        text: 'Import Detail',
        active: true,
      }
    ],
  },
  {
    path: "/custom-inventory/product/list",
    name: "custom-inventory-product-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
  },
  {
    path: "/custom-inventory/report",
    name: "custom-inventory-report",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
  },
  //fulfillment
    {
    path: '/custom-fulfillment/list',
    name: 'custom-fulfillment-list',
    component: () => import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
          text: 'Fulfillment',
          active: true,
      },
    ]
  },
  {
    path: '/custom-fulfillment/import/detail/:ref',
    name: 'custom-fulfillment-import-detail',
    component: () => import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
          text: 'Fulfillment/Import/TrackingNo',
          active: true,
      },
    ]
  },
  {
    path: '/custom-fulfillment/import/list',
    name: 'custom-fulfillment-import-list',
    component: () => import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
          text: 'Fulfillment/Import/TrackingNo/List',
          active: true,
      },
    ]
  },
  //banner
    {
    path: '/custom-banner/list/:ref',
    name: 'custom-banner-list',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: { },
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/group/:ref',
    name: 'custom-banner-group',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
      breadcrumb: [
        {
          text: 'Banner Management',
        },
        {
          text: 'Banner Group',
          active: true,
        },
      ],
  },
  {
    path: '/custom-banner/set/:ref',
    name: 'custom-set-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set List',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/list/:ref/create',
    name: 'custom-create-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
      },
      {
        text: 'Add Banner',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/list/:ref/:bannerId/info',
    name: 'custom-banner-info',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/set/:ref/create',
    name: 'custom-create-set-banner',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set List',
      },
      {
        text: 'Create Banner Set ',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/group/:ref/create',
    name: 'custom-create-banner-group',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Create Banner Group',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/set/:ref/:setBannerId/info',
    name: 'custom-set-banner-info',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set List',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/set/:ref/:setBannerId/info/banner/:bannerId/info',
    name: 'custom-set-banner-info-edit-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/group/:ref/:id/info',
    name: 'custom-group-banner-info',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Banner Group Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/custom-banner/group/:ref/:bannerGroupId/info/set/:setBannerId/info',
    name: 'custom-group-banner-info-edit-set-banner',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: { },
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/custom-banner/group/:ref/:bannerGroupId/info/set/:setBannerId/info/banner/:bannerId/info',
    name: 'custom-group-banner-info-edit-set-banner-edit-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/group/:ref/set/:setBannerId/info',
    name: 'custom-group-banner-list-edit-set-banner',
    component: () =>
      import(
        '@/views/pages/customs-module/CustomModule.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/custom-banner/group/:ref/set/:setBannerId/info/banner/:bannerId/info',
    name: 'custom-group-banner-list-edit-set-banner-edit-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: ' Banner Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/custom-banner/group/:ref/:bannerGroupId/info/banner/info/:bannerId',
    name: 'custom-group-banner-info-edit-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/custom-banner/group/:ref/banner/info/:bannerId',
    name: 'custom-group-banner-list-edit-banner',
    component: () =>
      import('@/views/pages/customs-module/CustomModule.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  //survey
    {
    path: "/custom-quiz/quiz-list",
    name: "custom-quiz-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-quiz/create",
    name: "custom-quiz-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        to: "/custom-quiz/quiz-list",
      },
      {
        text: "Custom For Brand",
        active: true,
      },
    ],
  },
  {
    path: "/custom-quiz/info/:ref",
    name: "custom-quiz-info",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        to: "/custom-quiz/quiz-list",
      },
      {
        text: "Edit Quiz",
        active: true,
      },
    ],
  },
  {
    path: "/custom-quiz/dashborad/:ref",
    name: "custom-quiz-dashborad",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    props: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz Dashboard",
        active: true,
      },
    ],
  },
  {
    path: "/custom-survey/survey-list",
    name: "custom-survey-list",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        active: true,
      },
    ],
  },
  {
    path: "/custom-survey/create",
    name: "custom-survey-create",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        to: "/custom-survey/survey-list",
      },
    ],
  },
  {
    path: "/custom-survey/info/:ref",
    name: "custom-survey-info",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        to: "/custom-survey/survey-list",
      },
      {
        text: "Edit Survey",
        active: true,
      },
    ],
  },
  {
    path: "/custom-survey/dashborad/:ref",
    name: "custom-survey-dashborad",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey Dashboard",
        active: true,
      },
    ],
  },
  //tag
  {
    path: "/custom-tags/list",
    name: "custom-tags-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Tags'
      },
      {
        text: 'Tags List',
        active: true,
      },
    ],
  },
  {
    path: "/custom-tags/create",
    name: "custom-tags-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: 'Tags'
      },
      {
        text: 'Add Tag',
        active: true,
      },
    ],
  },
  {
    path: "/custom-tags/info/:ref",
    name: "custom-tags-info",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Tags'
      },
      {
        text: 'Add Tag',
        active: true,
      },
    ],
  },
  {
    path: "/custom-tags/report",
    name: "custom-tags-report",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: 'Tags'
      },
      {
        text: 'Report',
        active: true,
      },
    ],
  },
  //reconcile 
  {
    path: "/custom-reconcile-payment/list",
    name: "custom-reconcile-payment-list",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Reconcile Payment",
      },
      {
        text: "Document List View",
        active: true,
      },
    ],
  },
  {
    path: "/custom-reconcile-payment/report/create",
    name: "custom-reconcile-payment-report-create",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: { },
    breadcrumb: [
      {
        text: "Reconcile Payment",
      },
      {
        text: "Document List View",
        to: "/custom-reconcile-payment/list",
      },
      {
        text: "Document View",
        active: true,
      },
    ],
  },
  {
    path: "/custom-reconcile-payment/report/:id/edit",
    name: "custom-reconcile-payment-report-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Reconcile Payment",
      },
      {
        text: "Document List View",
        to: "/custom-reconcile-payment/list",
      },
      {
        text: "Document View",
        active: true,
      },
    ],
  },
  //edit transaction
  {
    path: "/custom-reconcile-payment/edit-transaction-list",
    name: "custom-reconcile-payment-all",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Reconcile Payment",
        active: true,
      },
    ],
  },
  {
    path: "/custom-reconcile-payment/:id/edit",
    name: "custom-reconcile-payment-transaction-edit",
    component: () => import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Reconcile Payment",
        to: "/custom-reconcile-payment/edit-transaction-list",
      },
      {
        text: "Edit Reconcile Payment",
        active: true,
      },
    ],
  },
];